// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  name: 'prod',
  apiHost: 'profile.service.onyxcentersource.com',
  apiUrl: 'https://profile.service.onyxcentersource.com/rest/public/',
  gecoPaymentUrl: 'https://payments.onyxcentersource.com/',
  commonServiceApiUrl: 'https://ocd.service.onyxcentersource.com/api/geco/',
  captchaSiteKey: '6Lde7tkUAAAAACopMVlCUo-Zv2Tkvdp7XWd3F-JL',
  captchaBaseUrl: 'https://www.recaptcha.net/recaptcha/api.js',
  cdnUrl: 'https://cdn.onyxcentersource.com/taprofile/',
  aprUrl: 'https://apr.onyxcentersource.com/',
  o2Url: 'https://onyxpay.onyxcentersource.com/',
  o2ProductName: 'OnyxPay',  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
